import React from "react";
import { getVenueInfo, mapsUrl } from "../utils/venueInfo";

// Collapsible shopfront details for the selected venue, rendered under the tabs.
//
// Uses native <details>/<summary>: no state to manage, keyboard and screen-reader
// behaviour comes free, and it starts collapsed so it never pushes the roster
// down the page. The summary still shows the venue name and street at a glance,
// which is the most commonly wanted bit.
function VenueInfo({ venue }) {
  const info = getVenueInfo(venue);
  if (!info) return null;

  // "5 Gerald Street, Marrickville NSW 2204" -> "5 Gerald Street"
  const shortAddress = info.address.split(",")[0];

  return (
    <details className="venue-info mb-3">
      <summary>
        {/* Grouped into one flex child so the name/address wrap inside it and the
            open/close indicator (summary::after) stays on the first line. */}
        <span className="venue-info__head">
          <span className="venue-info__name">{info.name}</span>
          <span className="venue-info__sep" aria-hidden="true">
            ·
          </span>
          <span className="venue-info__addr">{shortAddress}</span>
        </span>
      </summary>

      <div className="venue-info__body">
        <dl className="venue-info__rows">
          <dt>Website</dt>
          <dd>
            <a href={info.website} target="_blank" rel="noopener noreferrer">
              {info.website.replace(/^https?:\/\//, "")}
            </a>
          </dd>

          <dt>Address</dt>
          <dd>
            <a href={mapsUrl(info.address)} target="_blank" rel="noopener noreferrer">
              {info.address}
            </a>
            {info.addressNote && (
              <div className="venue-info__note">{info.addressNote}</div>
            )}
          </dd>

          <dt>Phone</dt>
          <dd>
            {/* tel: so it dials on a phone and is still copyable on desktop */}
            <a href={`tel:${info.phoneDial}`}>{info.phone}</a>
          </dd>

          {info.hours && (
            <>
              <dt>Hours</dt>
              <dd>{info.hours}</dd>
            </>
          )}
        </dl>

        <p className="venue-info__disclaimer">
          Details are from the venue's own website and may change — please confirm with
          the venue before travelling.
        </p>
      </div>
    </details>
  );
}

export default VenueInfo;
